export default "__VITE_ASSET__yP2JRu1q__"